import React from 'react';
import { StyledGroupAvatar, StyledExpandablePlaceholder } from 'components/Shared/style';

const Placeholder = () => (
    <StyledExpandablePlaceholder className="ui-item">
        <StyledGroupAvatar className="s-group-avatar xs">&nbsp;</StyledGroupAvatar>
        <div className="name">&nbsp;</div>
    </StyledExpandablePlaceholder>
);

export default Placeholder;
